(function () {
  'use strict';

  var TURBO_AIR_LOGO = 'https://www.turboairinc.com/wp-content/uploads/2019/10/Logo_Stainless_Dark_TA-1.svg';

  function clean(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function important(element, property, value) {
    if (element && (element.style.getPropertyValue(property) !== value || element.style.getPropertyPriority(property) !== 'important')) {
      element.style.setProperty(property, value, 'important');
    }
  }

  function turboAirLogo() {
    var image = document.createElement('img');
    image.className = 'amc-card-brand__logo amc-turbo-air-logo';
    image.src = TURBO_AIR_LOGO;
    image.alt = 'Turbo Air';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.addEventListener('error', function () {
      var fallback = document.createElement('span');
      fallback.className = 'amc-card-brand__code';
      fallback.textContent = 'Turbo Air';
      image.replaceWith(fallback);
    }, { once: true });
    return image;
  }

  function installTurboAirLogos() {
    document.querySelectorAll('.amc-cslider').forEach(function (slider) {
      var section = slider.closest('.shopify-section');
      var heading = clean(slider.querySelector('.amc-cslider__brand') && slider.querySelector('.amc-cslider__brand').textContent);
      var isTurboAir = /amc_slider_turbo_air/i.test(section && section.id) || /Turbo Air/i.test(heading);
      if (!isTurboAir) return;
      slider.querySelectorAll('.amc-cslider__card .amc-cslider__vendor').forEach(function (vendor) {
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        var brandWidth = isMobile ? '68px' : '76px';
        var cardBody = vendor.closest('.amc-cslider__body');
        vendor.classList.add('amc-card-brand', 'amc-card-brand--turbo-air');
        important(vendor, 'width', brandWidth);
        important(vendor, 'min-width', brandWidth);
        important(vendor, 'max-width', brandWidth);
        important(cardBody, 'grid-template-columns', brandWidth + ' minmax(0, 1fr)');
        var existing = vendor.querySelector('.amc-turbo-air-logo');
        if (!existing || existing.getAttribute('src') !== TURBO_AIR_LOGO) vendor.replaceChildren(turboAirLogo());
      });
    });

    document.querySelectorAll('.product-card[data-product-vendor="turbo-air"] .amc-card-brandline').forEach(function (brandLine) {
      var existing = brandLine.querySelector('.amc-turbo-air-logo');
      if (!existing || existing.getAttribute('src') !== TURBO_AIR_LOGO) brandLine.replaceChildren(turboAirLogo());
    });
  }

  function placeHomepageBottomBands() {
    var main = document.querySelector('#MainContent');
    var resourceNav = main && main.querySelector('.amc-cats__tools');
    var brandStrip = main && main.querySelector('.amc-bstrip');
    var brandSection = brandStrip && brandStrip.closest('.shopify-section');
    if (!main || !resourceNav) return;

    if (main.querySelector('.amc-resource-showcase')) {
      important(resourceNav, 'display', 'none');
      resourceNav.setAttribute('aria-hidden', 'true');
      var legacyResourceSection = main.querySelector('.amc-home-bottom-resources');
      if (legacyResourceSection) legacyResourceSection.remove();
      if (brandSection) important(brandSection, 'display', 'none');
      return;
    }

    if (!brandSection) return;

    var resourceSection = main.querySelector('.amc-home-bottom-resources');
    if (!resourceSection) {
      resourceSection = document.createElement('section');
      resourceSection.className = 'amc-home-bottom-resources';
      resourceSection.setAttribute('aria-label', 'Buyer resources');
      var resourceInner = document.createElement('div');
      resourceInner.className = 'page-width';
      resourceSection.appendChild(resourceInner);
    }
    var resourceContainer = resourceSection.querySelector('.page-width');
    if (resourceNav.parentElement !== resourceContainer) resourceContainer.appendChild(resourceNav);

    var resources = [
      ['Financing', 'Payment and equipment financing options'],
      ['Get a quote', 'Pricing, lead times and purchase-order support'],
      ['Planning guides', 'Sizing, capacity and site preparation'],
      ['Delivery guide', 'Freight, unloading and access requirements']
    ];
    var resourceHead = resourceNav.querySelector('.amc-cats__tools-head');
    var resourceLabel = resourceNav.querySelector('.amc-cats__tools-label');
    var resourceSub = resourceHead && resourceHead.querySelector('small');
    if (resourceLabel) resourceLabel.textContent = 'Buyer resources';
    if (resourceSub) resourceSub.textContent = 'Quotes, planning, payment and delivery';
    resourceNav.querySelectorAll('.amc-cats__tool-card').forEach(function (card, index) {
      var copy = resources[index];
      if (!copy) return;
      var title = card.querySelector('.amc-cats__tool-copy strong');
      var detail = card.querySelector('.amc-cats__tool-copy small');
      if (title) title.textContent = copy[0];
      if (detail) detail.textContent = copy[1];
      card.setAttribute('aria-label', copy[0] + ': ' + copy[1]);
    });

    if (brandStrip) {
      brandStrip.open = true;
      var brandLabel = brandStrip.querySelector('.amc-bstrip__label');
      if (brandLabel) brandLabel.textContent = 'Our family of brands';
      var brandSummary = brandStrip.querySelector('.amc-bstrip__sum');
      if (brandSummary && !brandSummary.dataset.amcStatic) {
        brandSummary.dataset.amcStatic = 'true';
        brandSummary.addEventListener('click', function (event) {
          event.preventDefault();
        });
      }
    }

    if (resourceSection.parentElement !== main ||
        resourceSection.nextElementSibling !== brandSection ||
        brandSection.nextElementSibling !== null) {
      main.append(resourceSection, brandSection);
    }
  }

  function tightenHomepage() {
    installTurboAirLogos();
    if (!document.body || !document.body.classList.contains('index-template')) return;

    var featureBar = document.querySelector('.amc-hero__featurebar');
    if (featureBar) {
      var featureLabel = featureBar.querySelector('strong');
      var featureStatus = featureBar.querySelector('em');
      if (featureLabel) featureLabel.textContent = 'Featured equipment';
      if (featureStatus) featureStatus.textContent = 'Current catalog';
    }

    document.querySelectorAll('.amc-hero__barcode').forEach(function (barcode) {
      barcode.remove();
    });

    document.querySelectorAll('.amc-hero__identity').forEach(function (identity) {
      var heroPo = identity.querySelector('.amc-hero__po');
      var heroModel = clean(heroPo && heroPo.textContent).replace(/^Order\s*\/\s*PO\s*/i, '');
      if (!heroModel) return;
      var heroLabel = document.createElement('span');
      var heroValue = document.createElement('strong');
      heroLabel.textContent = 'Model';
      heroValue.className = 'amc-hero__model';
      heroValue.textContent = heroModel;
      identity.replaceChildren(heroLabel, heroValue);
      identity.setAttribute('aria-label', 'Model ' + heroModel);
    });

    document.querySelectorAll('.amc-cslider__card').forEach(function (card) {
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      important(card, 'height', 'auto');
      important(card, 'min-height', '0');
      important(card, 'max-height', 'none');

      [card.querySelector('.amc-cslider__media-link'), card.querySelector('.amc-cslider__imgwrap')].forEach(function (media) {
        important(media, 'height', 'auto');
        important(media, 'min-height', '0');
        important(media, 'max-height', 'none');
        important(media, 'aspect-ratio', '4 / 3');
      });

      var cardBody = card.querySelector('.amc-cslider__body');
      important(cardBody, 'height', 'auto');
      important(cardBody, 'min-height', '0');
      important(cardBody, 'max-height', 'none');
      important(cardBody, 'grid-template-rows', 'none');

      card.querySelectorAll('.amc-cslider__flag,.amc-cslider__dealbar,.amc-cslider__shipping,.amc-epa-cue,.amc-value-line').forEach(function (element) {
        element.remove();
      });

      var model = card.querySelector('.amc-cslider__model');
      if (model) {
        if (model.dataset.amcTightSku === 'true') {
          var existingLabel = model.querySelector('span');
          var existingValue = model.querySelector('strong');
          if (existingLabel) existingLabel.textContent = 'SKU';
          if (existingValue && model.dataset.amcTightSkuValue) existingValue.textContent = model.dataset.amcTightSkuValue;
        } else {
          var po = model.querySelector('.amc-cslider__po');
          var sku = clean(po && po.textContent).replace(/^Order\s*\/\s*PO\s*/i, '');
          if (sku) {
            var label = document.createElement('span');
            var value = document.createElement('strong');
            label.textContent = 'SKU';
            value.textContent = sku;
            model.replaceChildren(label, value);
            model.setAttribute('aria-label', 'SKU ' + sku);
            model.dataset.amcTightSku = 'true';
            model.dataset.amcTightSkuValue = sku;
          } else {
            model.remove();
          }
        }
      }

      var price = card.querySelector('.amc-cslider__price-column strong');
      var priceLabel = card.querySelector('.amc-cslider__price-column small');
      var compare = card.querySelector('.amc-cslider__compare-column s');
      var hasCompare = !!clean(compare && compare.textContent);
      if (priceLabel) priceLabel.textContent = 'Current price';

      var savings = card.querySelector('.amc-cslider__savings');
      if (savings) {
        var savingsPrimary = savings.querySelector('strong');
        var savingsSecondary = savings.querySelector('span');
        if (hasCompare) {
          if (savingsSecondary) savingsSecondary.textContent = 'Compare at';
        } else {
          if (savingsPrimary) savingsPrimary.textContent = (window.amcPriceLabel || 'Sale price');
          if (savingsSecondary) savingsSecondary.textContent = 'Options may vary';
        }
      }

      var action = card.querySelector('.amc-cslider__action');
      if (action && action.tagName === 'A') {
        action.textContent = 'View details';
        var productTitle = clean(card.querySelector('.amc-cslider__title') && card.querySelector('.amc-cslider__title').textContent);
        if (productTitle) action.setAttribute('aria-label', 'View details — ' + productTitle);
      }
    });

    var guideDetails = document.querySelector('.amc-guides__acc');
    if (guideDetails && !guideDetails.dataset.amcTightened) {
      guideDetails.removeAttribute('open');
      guideDetails.dataset.amcTightened = 'true';
    }

    document.querySelectorAll('body.index-template .amc-promo strong, body.index-template .amc-promo span, body.index-template .amc-promo em').forEach(function (element) {
      var value = clean(element.textContent);
      if (/big savings\s*[·-]?\s*ends soon/i.test(value)) element.textContent = 'Current equipment pricing';
    });

    document.querySelectorAll('body.index-template .amc-promo a[href*="/collections/mortuary-coolers"]').forEach(function (link) {
      var promoTitle = link.querySelector('strong');
      var promoCopy = link.querySelector('span');
      if (promoTitle) promoTitle.textContent = 'COOLER PRICING';
      if (promoCopy) promoCopy.textContent = 'Current factory-direct pricing';
      link.setAttribute('aria-label', 'Cooler pricing — current factory-direct pricing — shop coolers');
    });

    placeHomepageBottomBands();
  }

  function run() {
    tightenHomepage();
    installPaymentLogos();
    alignPriceActions();
    connectRfqLinks();
  }

  function installPaymentLogos() {
    const homepage=document.body.classList.contains('index-template');
    if(homepage){
      document.querySelectorAll('#MainContent .amc-card-payment-logo,#MainContent .amc-timepayment-offer,#MainContent .amc-card-timepayment').forEach(element=>element.remove());
    }
    document.querySelectorAll('.card-wrapper,.amc-cslider__card,.amc-equipment-product,.amc-market-card,.amc-cd-rec,.amc-trending-card').forEach(card=>{
      if(card.closest('[data-amc-instinct]')){
        card.querySelectorAll('.amc-card-payment-logo,.amc-timepayment-offer,.amc-card-terms-slot').forEach(e=>{if(!e.closest('.amc-viewing-card__pay'))e.remove()});
        return;
      }
      if(card.parentElement?.closest('.card-wrapper,.amc-cslider__card,.amc-equipment-product,.amc-market-card,.amc-cd-rec,.amc-trending-card')) return;
      let anchor=card.querySelector('.amc-card-payment-logo');
      const action=card.querySelector('[data-amc-card-submit],a[data-amc-qa="fetch"],modal-opener button,.amc-market-card__add,.amc-cslider__cta[href*="/products/"],.amc-cd-rec__add,.quick-add__submit');
      const actionBlock=action?.closest('.amc-card-purchase-row,.amc-market-card__actions,.amc-cslider__actions,.quick-add,modal-opener')||action;
      const finance=card.querySelector('.amc-card-timepayment,.amc-timepayment-offer--card');
      if(finance&&actionBlock&&!finance.contains(actionBlock)&&finance.parentElement===actionBlock.parentElement&&finance.compareDocumentPosition(actionBlock)&Node.DOCUMENT_POSITION_PRECEDING)actionBlock.before(finance);
      if(finance){
        if(anchor)anchor.remove();
        card.classList.remove('amc-has-payment-logo');
        finance.classList.add('amc-payment-inline');
        finance.title='Monthly equipment estimate. Subject to lender approval and terms. Tax and delivery extra.';
      }else{
        // No logo-only financing placeholder on inexpensive or quote-only cards.
        // Genuine eligible non-homepage equipment offers keep their native slot.
        if(anchor)anchor.remove();
        card.classList.remove('amc-has-payment-logo');
      }
      if(action && document.body.classList.contains('index-template') && !/quote|sold out|unavailable|configure/i.test(action.textContent) && !action.querySelector('.amc-qa-plus')){
        const name=card.querySelector('h3,h4,.amc-market-card__title,.amc-cslider__title,.card__heading,.amc-trending-title')?.textContent.trim()||'this product';
        action.innerHTML='<span class="amc-qa-plus" aria-hidden="true">+</span><span>Quick add</span>';
        action.classList.add('amc-quick-add-action');
        action.setAttribute('aria-label','Quick add: '+name);
      }
      if(action?.classList.contains('amc-quick-add-action')&&!action.classList.contains('amc-price-plus')){
        const plus=action.querySelector('.amc-qa-plus');
        if(plus){important(plus,'display','inline-grid');important(plus,'place-items','center');important(plus,'width','23px');important(plus,'height','23px');important(plus,'background','#C8161D');important(plus,'color','#fff');important(plus,'border-radius','50%');important(plus,'font','500 22px/1 Arial,sans-serif');important(plus,'flex','0 0 23px')}
        important(action,'display','flex');important(action,'align-items','center');important(action,'justify-content','center');important(action,'gap','8px');important(action,'min-height','44px');important(action,'height','44px');important(action,'background','#fff');important(action,'color','#143a59');important(action,'border','1px solid #b8cbde');important(action,'border-radius','6px');
      }
    });
  }
  function alignPriceActions(){
    if(!document.body.classList.contains('index-template'))return;
    document.querySelectorAll('.amc-market-card,.amc-cslider__card').forEach(card=>{
      const price=card.querySelector('.amc-card-price__current,.amc-cslider__price-row');
      const action=card.querySelector('[data-amc-card-submit],a[data-amc-qa="fetch"],modal-opener button,.quick-add__submit,.amc-market-card__cta[data-amc-qa],.amc-cslider__action[data-amc-qa]');
      if(!price||!action||/sold out|unavailable|quote/i.test(action.textContent))return;
      const block=action.closest('.amc-card-purchase-row,.amc-market-card__actions,.amc-cslider__actions,.quick-add')||action.closest('modal-opener')||action;
      if(block.contains(price))return;
      const name=card.querySelector('h3,h4,.amc-cslider__title')?.textContent.trim()||'this product';
      const configure=/configure/i.test(action.textContent)||action.dataset.amcQa==='builder';
      price.classList.add('amc-price-action-line');
      if(block.parentElement!==price)price.append(block);
      important(price,'display','flex');important(price,'align-items','center');important(price,'justify-content','space-between');important(price,'flex-wrap','nowrap');important(price,'gap','6px');
      if(block!==action){important(block,'display','flex');important(block,'flex','0 0 44px');important(block,'width','44px');important(block,'min-width','44px');important(block,'margin','0');important(block,'padding','0');}
      action.classList.add('amc-price-plus');
      if(!action.querySelector('.amc-qa-plus'))action.innerHTML='<span class="amc-qa-plus" aria-hidden="true">+</span><span class="visually-hidden">'+(configure?'Configure':'Quick add')+'</span>';
      action.querySelectorAll(':scope>span:not([aria-hidden])').forEach(label=>label.classList.add('visually-hidden'));
      action.setAttribute('title',configure?'Choose options':'Quick add');
      action.setAttribute('aria-label',(configure?'Choose options: ':'Quick add: ')+name);
      important(action,'display','grid');important(action,'place-items','center');important(action,'width','44px');important(action,'min-width','44px');important(action,'max-width','44px');important(action,'height','44px');important(action,'padding','0');important(action,'border','0');important(action,'border-radius','50%');important(action,'background','#C8161D');important(action,'color','#fff');important(action,'flex','0 0 44px');
      const plus=action.querySelector('.amc-qa-plus');
      important(plus,'display','grid');important(plus,'place-items','center');important(plus,'width','28px');important(plus,'height','28px');important(plus,'color','#fff');important(plus,'background','transparent');important(plus,'font-size','27px');
    });
  }
  function connectRfqLinks(){
    document.querySelectorAll('a[href*="/pages/rfq-center"]').forEach(a=>{
      let url;try{url=new URL(a.getAttribute('href'),location.origin)}catch{return}
      if(url.origin!==location.origin||url.pathname.replace(/\/$/,'')!=='/pages/rfq-center')return;
      url.pathname='/pages/purchase-order';url.searchParams.set('type','rfq');url.hash='';
      a.href=url.href;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('amc:cards-loaded', ()=>{installPaymentLogos();alignPriceActions();});
  let paymentFrame=0,paymentBusy=false;
  const paymentSkip=n=>n.nodeType!==1||!!(n.closest&&n.closest('shopify-payment-terms,.amc-card-terms-slot,.amc-card-shop-pay-terms,[class*="shop-pay"],script,style'));
  const paymentRun=()=>{paymentBusy=true;paymentMo.disconnect();try{installPaymentLogos();alignPriceActions();connectRfqLinks();}finally{paymentMo.takeRecords();paymentMo.observe(document.documentElement,{childList:true,subtree:true});paymentBusy=false;}};
  /* 2026-10-25 perf: pause the watcher while this script edits cards, so its own edits
     (and Shop Pay terms re-rendering inside cards) no longer re-trigger it every frame. */
  const paymentMo=new MutationObserver(records=>{
    if(paymentBusy||!records.some(r=>[...r.addedNodes].some(n=>!paymentSkip(n)))) return;
    clearTimeout(paymentFrame);
    paymentFrame=setTimeout(()=>requestAnimationFrame(paymentRun),200);
  });
  paymentMo.observe(document.documentElement,{childList:true,subtree:true});
  var resizeFrame;
  window.addEventListener('resize', function () {
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(tightenHomepage);
  }, { passive: true });
}());
